/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { SimplifiedLookupResponseViewModel } from './SimplifiedLookupResponseViewModel';
import {
    SimplifiedLookupResponseViewModelFromJSON,
    SimplifiedLookupResponseViewModelFromJSONTyped,
    SimplifiedLookupResponseViewModelToJSON,
} from './SimplifiedLookupResponseViewModel';

/**
 * 
 * @export
 * @interface ResultOfListOfSimplifiedLookupResponseViewModel
 */
export interface ResultOfListOfSimplifiedLookupResponseViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<SimplifiedLookupResponseViewModel>}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    data?: Array<SimplifiedLookupResponseViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfSimplifiedLookupResponseViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfSimplifiedLookupResponseViewModel interface.
 */
export function instanceOfResultOfListOfSimplifiedLookupResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfSimplifiedLookupResponseViewModelFromJSON(json: any): ResultOfListOfSimplifiedLookupResponseViewModel {
    return ResultOfListOfSimplifiedLookupResponseViewModelFromJSONTyped(json, false);
}

export function ResultOfListOfSimplifiedLookupResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfSimplifiedLookupResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(SimplifiedLookupResponseViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfSimplifiedLookupResponseViewModelToJSON(value?: ResultOfListOfSimplifiedLookupResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(SimplifiedLookupResponseViewModelToJSON)),
        'Count': value.count,
    };
}

